$(document).ready(function() {

	// home page scripts
	if ($('body').hasClass('page-template-page-beacon-home')) {
		facilityPhotos();
	}
	
	// facility location map
	if ($('.beacon-map').length && $('.beacon-map').attr('data-latitude') && $('.beacon-map').attr('data-longitude')) {
		var latitude = $('.beacon-map').attr('data-latitude');
		var longitude = $('.beacon-map').attr('data-longitude');
		simpleMap(latitude, longitude, 'beacon-facility-map');
	}

});
